<template>
  <div class="player-profile-card p-3 pb-5" :style="{ width }">

    <div class="row justify-content-center">
      <div class="col-12 col-sm-5 mb-sm-3">
        <div class="player-profile-card__player_image">
          <div class="relatives_container" v-if="player.linked_list">
            <img :src="getPlayerImage(r.id)" width="100%" :class="`relative-image image-${ix}`" v-for="(r, ix) in player.linked_list" :key="r.id"/>
            <img class="relative-image image-center" :src="getPlayerImage(player.id)" alt="Profile image" />
          </div>
          <img v-if="!player.linked_list" class="player-profile-card__image" :src="getPlayerImage(player.id)" alt="Profile image" />
          <img class="player-profile-card__logo" alt="Logo" width="75px" src="../assets/pp_logo-coin.png" />
        </div>

      </div>

      <div class="col-12 col-sm-7 align-self-center mb-5">
        <div class="mb-3 text-center players-embed-title">
          <h4 class="players-embed-title__country m-0">
            {{ player.country }}
          </h4>
          <h3 class="players-embed-title__title m-0">
            {{ player.title }}
          </h3>
          <h3 class="players-embed-title__name m-0">
            {{ player.short_name }}
          </h3>
          <h3 v-if="player.sub_title" class="mb-1">{{ player.sub_title }}</h3>
        </div>

        <div class="text-center mt-4">
          <a class="btn btn-dark" target="_blank" :href="`https://www.icij.org/investigations/pandora-papers/power-players/?player=${kebabCase(player.short_name)}`">{{ $t('playerProfile.readMore') }} <IconArrowRight /></a>
        </div>

        <div class="mt-4 pb-3 text-center">
          <CustomSharingOptions class="justify-content-center" :title="`${$t('social.player')} ${translateIsoCountry(player.country_iso_3)} ${player.title} ${player.short_name}`" />
        </div>
      </div>
      
    </div>
    <AppFooterEmbed class="mt-5">
    </AppFooterEmbed>
  </div>
</template>

<script>

import CustomSharingOptions from '@/components/CustomSharingOptions'
import AppFooterEmbed from '@/components/AppFooterEmbed'
import IconArrowRight from '@/components/IconArrowRight'
import kebabCase from 'lodash/kebabCase'
import utils from '@/mixins/utils'

export default {
  name: 'PlayerProfileCard',
  mixins: [utils],
  props: {
    player: {
      type: Object
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  components: {
    IconArrowRight,
    AppFooterEmbed,
    CustomSharingOptions
  },
  computed: {
    href () {
      return this.$router.resolve({ name: 'client.profile', params: { id: kebabCase(this.client.short_name) } }).href
    }
  },
  methods: {
    kebabCase
  }
}
</script>

<style lang="scss">

  .players-embed-title {
    color: var(--app-color-black);

    &__title {
      font-size: 27px;
      color: var(--app-color-black);
    }

    &__name {
      font-size: 41px;
      color: var(--app-color-red);
    }

    &__country {
      font-size: 18px;
    }
    
    h5 {
      margin: 0;
      font-family: var(--headings-type-writer);
      letter-spacing: -1.5px;
      font-size: 17px;

      span {
        display: block;
        font-size: 13px;
      }
    }
  }

  .relatives_container {
    display: display;
    width: 100%;
    max-width: 300px;
    margin: 15px;

    h3 {
      margin: 5px 0;
      font-size: 18px;
      color: var(--app-color-black);
      text-align: center;
    }

    .relative-image {
      position: absolute;
      display: inline-block;
      width: 100%;
      max-width: 120px;
      border-radius: 100%;
      background: var(--app-color-black);

      &.image-1 {
        top: 0;
        left: 140px;
      }

      &.image-2 {
        bottom: 15px;
      }

      &.image-center {
        left: 90px;
        top: 90px;
        width: 100px;
        height: 100px;
        background-color: var(--app-color-dark);
      }
    }
  } 

  .player-profile-card {
    color: #fff;
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
    padding: 5px;

    &__player_image {
      position: relative;
      height: 280px;
      width: 260px;
      margin: 0 auto;
    }

    &__image {
      width: auto;
      height: 250px;
      background: var(--app-color-black);
      border-radius: 100%;
      overflow: hidden;
    }

    &__logo {
      position: absolute;
      width: 100%;
      max-width: 120px;
      bottom: 15px;
      right: 0;
    }

    &__name {
      font-size: 27px;
      font-weight: 900;
      color: var(--app-color-red);
    }

    &__country {
      color: var(--app-color-black);
      font-size: 16px;
      font-weight: 600;
    }

    &__title {
      color: var(--app-color-black);
      font-size: 21px;
      font-weight: 900;
    }

    &__read-more, &__read-more:hover {
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
</style>
